export const locale = {
  lang: 'it',
  data: {
    RIGHTS_RESERVED: 'Tutti i diritti riservati',
    PARTNERSHIP: 'Realizzato da ',
  }
};
